import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import TrustBar from "@/components/site/TrustBar";
import AirportPilot from "@/components/site/AirportPilot";
import CampusPilot from "@/components/site/CampusPilot";
import Concept from "@/components/site/Concept";
import Collection from "@/components/site/Collection";
import Locations from "@/components/site/Locations";
import WhyPartner from "@/components/site/WhyPartner";
import About from "@/components/site/About";
import Enquiries from "@/components/site/Enquiries";
import Footer from "@/components/site/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      touchMultiplier: 1.5,
    });
    function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  return (
    <div className="App bg-ink text-bone min-h-screen" data-testid="minisrus-app">
      <Header />
      <main>
        <Hero />
        <Collection />
        <TrustBar />
        <AirportPilot />
        <CampusPilot />
        <Concept />
        <Locations />
        <WhyPartner />
        <About />
        <Enquiries />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
